import React from "react"
import { Link } from "gatsby"

export default function EndorsementsLayout({ children, title }) {
  return (
    <>
      <h1 className="text-center">2026 Endorsements for State Offices</h1>
      <p>
        California Cities for Local Control endorsed many candidates for State
        office in the June Primary election. Congratulations to those who won
        and are moving on to the General Election. We hope our Endorsement was
        helpful!
      </p>
      <p>
        We now show the lists of State candidates for Governor, Assembly, Senate
        and Attorney General for the November General Election. We have given
        all candidates who didn't respond to our Endorsement questionnaire
        multiple opportunities to earn our endorsement and have now changed
        "Awaiting Response" to "Unresponsive". If your candidate would still
        like to submit their answers to us for consideration, please ask them to
        download and return the completed questionnaire as soon as possible!
      </p>
      <ul className="flex flex-wrap gap-9 mt-6 justify-center">
        <li>
          <a
            href="/documents/CCLC 2026 Election Endorsement Questionnaire FINAL.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Questionnaire
          </a>
        </li>
        <li>
          <Link to="/endorsements/assembly" activeClassName="underline">
            Assembly
          </Link>
        </li>
        <li>
          <Link to="/endorsements/senate" activeClassName="underline">
            Senate
          </Link>
        </li>
        <li>
          <Link to="/endorsements/governor" activeClassName="underline">
            Governor
          </Link>
        </li>
        <li>
          <Link to="/endorsements/attorney-general" activeClassName="underline">
            Attorney General
          </Link>
        </li>
      </ul>
      <h2 className="text-xl font-semibold mt-5">{title}</h2>

      <div className="mt-4">{children}</div>
    </>
  )
}
